import { Card, CardContent } from '@/components/ui/Card.tsx';
import { Skeleton } from '@/components/ui/Skeleton.tsx';

const SummaryRow = () => (
  <div className="flex flex-row justify-between">
    <Skeleton className="h-5 w-40" />
    <Skeleton className="h-5 w-20" />
  </div>
);

const BookingSummarySkeleton = () => {
  return (
    <div className="space-y-2">
      <Card>
        <CardContent className="space-y-3">
          <Skeleton className="h-6 w-44" />
          <div className="flex flex-row gap-2">
            <Skeleton className="h-9 flex-1" />
            <Skeleton className="h-9 w-24" />
          </div>
        </CardContent>

        <CardContent className="space-y-2">
          <Skeleton className="mb-4 h-6 w-48" />
          <SummaryRow />
          <SummaryRow />
          <SummaryRow />
        </CardContent>

        <CardContent className="space-y-2">
          <Skeleton className="h-6 w-40" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
        </CardContent>
      </Card>
    </div>
  );
};

export default BookingSummarySkeleton;
